(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-as-track]');
    if (!track) return;
    var prev = root.querySelector('[data-as-prev]');
    var next = root.querySelector('[data-as-next]');
    var bar = root.querySelector('[data-as-progress]');

    function step() {
      var item = track.children[0];
      if (!item) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar && max > 0) {
        var visible = track.clientWidth / track.scrollWidth;
        var offset = track.scrollLeft / track.scrollWidth;
        bar.style.width = visible * 100 + '%';
        bar.style.transform = 'translateX(' + offset / visible * 100 + '%)';
      } else if (bar) {
        bar.style.width = '100%';
        bar.style.transform = 'none';
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initTabs(root) {
    var buttons = root.querySelectorAll('[data-as-tab]');
    var panels = root.querySelectorAll('[data-as-tab-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.asTabPanel === btn.dataset.asTab);
        });
      });
    });
  }

  function initCollectionTabs(root) {
    root.querySelectorAll('[data-as-collection-tabs]').forEach(function (tabsRoot) {
      if (tabsRoot.dataset.asCollectionTabsBound) return;
      tabsRoot.dataset.asCollectionTabsBound = 'true';
      var buttons = tabsRoot.querySelectorAll('[data-as-collection-tab]');
      var panels = tabsRoot.querySelectorAll('[data-as-collection-panel]');

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var selected = button.dataset.asCollectionTab;

          buttons.forEach(function (candidate) {
            var active = candidate === button;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var active = panel.dataset.asCollectionPanel === selected;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });
  }

  function initQuickAdd(scope) {
    scope.querySelectorAll('[data-as-add]').forEach(function (btn) {
      if (btn.dataset.asAddBound) return;
      btn.dataset.asAddBound = 'true';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var id = Number(btn.dataset.asAdd);
        if (!id) return;
        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            btn.classList.remove('is-loading');
          })
          .catch(function () {
            var url = btn.dataset.asAddUrl;
            if (url) window.location.href = url;
            btn.classList.remove('is-loading');
          });
      });
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-as-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-as-tabs]').forEach(initTabs);
    initCollectionTabs(scope);
    initQuickAdd(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
